define.alias("ember-math-helpers/helpers/asin", "preview-grid/helpers/asin");